<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama, file, atau surat&hellip;"
                 aria-label="Cari audio" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter surat"
                  (change)="isSurah = $event.target.value; applyFilter()">
            <option value="" [selected]="!isSurah">Semua surat</option>
            <option *ngFor="let s of dataSurah" [value]="s.id" [selected]="isSurah == s.id">{{s.text}}</option>
          </select>
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Tambah Audio</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Surat</th>
                  <th>Ayat Terisi</th>
                  <th>Terakhir Diperbarui</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let g of isGrouped; let gi = index">
                  <!-- surah group row — expandable -->
                  <tr class="vl-top" [class.vl-alt]="gi % 2 == 1" (click)="toggleGroup(g)">
                    <th class="vl-num">
                      {{rowNo(gi)}}
                      <span class="vl-chev" [class.open]="isExpanded[g.id] && !g.loading">
                        <i class="fa" [ngClass]="g.loading ? 'fa-spinner fa-spin' : 'fa-chevron-right'"></i></span>
                    </th>
                    <td>
                      <div class="vl-name-wrap">
                        <span [innerHTML]="highlight(g.name)"></span>
                        <span class="vl-chip">{{formatNumber(g.fileCount)}} file</span>
                      </div>
                    </td>
                    <td class="vl-muted">{{formatNumber(g.ayahCount)}} / {{formatNumber(g.totalAyah)}} ayat</td>
                    <td class="vl-muted vl-small">{{g.updatedVw}}</td>
                    <td>
                      <div class="vl-actions">
                        <button type="button" class="vl-icon" title="Unggah audio ke surat ini"
                                (click)="$event.stopPropagation(); onShowAdd(g.id)" data-bs-toggle="modal"
                                data-bs-target="#formData"><i class="fa fa-file-upload"></i></button>
                      </div>
                    </td>
                  </tr>
                  <!-- per-ayah members -->
                  <ng-container *ngIf="isExpanded[g.id]">
                    <tr *ngFor="let it of g.visible; let j = index" class="vl-child">
                      <th class="vl-num">{{rowNo(gi)}}.{{j + 1}}</th>
                      <td colspan="2">
                        <span class="vl-file-wrap">
                          <span class="vl-tree">&#9492;</span>
                          <span class="vl-ayah-chip">Ayat {{it.ayah}}<span class="vl-seq" *ngIf="it.hasTwin"> &middot; {{it.seq}}</span></span>
                          <button type="button" class="vl-icon play" [class.on]="playingId === it.id" *ngIf="it.file"
                                  [title]="playingId === it.id ? 'Jeda' : 'Putar'" (click)="togglePlay(it)">
                            <i class="fa" [ngClass]="playingId === it.id ? 'fa-pause' : 'fa-play'"></i></button>
                          <code class="vl-code" *ngIf="it.file" [innerHTML]="highlight(it.file)"></code>
                          <span class="vl-muted" *ngIf="!it.file">&mdash;</span>
                        </span>
                      </td>
                      <td class="vl-muted vl-small">{{it.updatedVw}}</td>
                      <td>
                        <div class="vl-actions">
                          <button type="button" class="vl-icon dl" title="Unduh" *ngIf="it.file"
                                  [disabled]="isDownloadingId === it.id" (click)="downloadFile(it)">
                            <i class="fa" [ngClass]="isDownloadingId === it.id ? 'fa-spinner fa-spin' : 'fa-download'"></i></button>
                          <button type="button" class="vl-icon" title="Edit" (click)="onEdit(it)" data-bs-toggle="modal"
                                  data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                          <button type="button" class="vl-icon danger" title="Hapus" (click)="onDelete(it)"><i class="fa fa-trash"></i></button>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="g.items.length && g.visible.length < g.items.length" class="vl-child">
                      <th class="vl-num"></th>
                      <td colspan="4" class="vl-muted vl-small">
                        {{formatNumber(g.items.length - g.visible.length)}} file lain di surat ini tidak cocok dengan pencarian.</td>
                    </tr>
                    <tr *ngIf="!g.items.length && !g.loading" class="vl-child">
                      <th class="vl-num"></th>
                      <td colspan="4" class="vl-muted vl-small">Belum ada file audio di surat ini.</td>
                    </tr>
                  </ng-container>
                </ng-container>
                <tr *ngIf="!isGrouped.length">
                  <td colspan="5" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> surat</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit audio' : 'Tambah audio'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui ' + isEditLabel + '.' : 'Unggah file audio murottal per ayat.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full" [class.vf-invalid]="isInvalid('surah')">
              <label class="vf-label">Surat <span class="req">*</span></label>
              <ng-select2 formControlName="surah" [data]="dataSurah"
                          [placeholder]="'Pilih surat'"></ng-select2>
              <div class="vf-error" *ngIf="isInvalid('surah')">Surat wajib dipilih.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Ayat <span class="req">*</span></label>
              <input type="number" min="1" inputmode="numeric" class="vf-input" [class.invalid]="isInvalid('ayah')"
                     placeholder="Nomor ayat, misal: 1" formControlName="ayah">
              <div class="vf-error" *ngIf="isInvalid('ayah')">Ayat wajib diisi (minimal 1).</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">File Audio <span class="req" *ngIf="!isForm.value.id">*</span></label>
              <input class="vf-input vf-file" type="file" accept="audio/*" [class.invalid]="isInvalid('file')"
                     formControlName="file" (change)="onFileSelect($event)">
              <div class="vf-hint" *ngIf="isForm.value.id">Biarkan kosong jika file tidak diganti.</div>
              <div class="vf-error" *ngIf="isInvalid('file')">File audio wajib diunggah.</div>
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- delete confirmation dialog (custom, design-system styled) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
      </span>
      <h3>Hapus audio ini?</h3>
      <p>Tindakan ini tidak bisa dibatalkan.</p>
      <div class="hds-item">
        <span>{{isConfirm.v.quran_surah.name}} &mdash; {{ayahLabel(isConfirm.v)}}</span>
      </div>
      <div class="hds-file" *ngIf="isConfirm.v.file"><code class="vl-code">{{isConfirm.v.file}}</code></div>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
        <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
    </div>
  </div>
</div>
